import React, { Component } from 'react'
import UserForm from './UserForm'

export default class UserInformation extends Component {
    render() {
        return (
            <div>
                <UserForm/>
            </div>
        )
    }
}
